import { Link } from "@tanstack/react-router";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const NotFound = () => {
  return (
    <>
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <main className="flex-1 flex items-center justify-center section-padding">
          <div className="container-custom text-center max-w-xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Seite nicht gefunden</h1>
            <p className="text-lg text-muted-foreground mb-8">
              Die Seite, die Sie aufgerufen haben, gibt es nicht oder nicht mehr.
            </p>
            <Link
              to="/"
              className="inline-flex items-center rounded-md bg-primary text-primary-foreground px-6 py-3 font-medium hover:opacity-90 transition-opacity"
            >
              Zur Startseite
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
